import { useState,useEffect } from "react";

import { Container,Row,Col } from "react-bootstrap"
import {ArrowRightCircle} from "react-bootstrap-icons";
import headerImg from "../assets/img/robot-svgrepo-com (1).svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";
export const Banner = () => {
    const [loopNum,setLoopNum] = useState(0);
    const [activeLink, setActiveLink] = useState('home');
    const [isDeleting,setIsDeleting] = useState(false);
    const toRotate = ["Machine Learning Developer"," Computer Vision Developer","Deep Learning Expert"];
    const [text,setText] = useState('');
    const [index, setIndex] = useState(1);
    const [delta,setDelta] = useState(500 - Math.random()*100);
    const period = 500;
    useEffect(() =>{
        let ticker = setInterval(() =>{
            tick();
        },delta)
        return () =>{clearInterval(ticker)};
    },[text])
    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
    
        setText(updatedText);
    
        if (isDeleting) {
          setDelta(prevDelta => prevDelta / 2);
        }
    
        if (!isDeleting && updatedText === fullText) {
          setIsDeleting(true);
          setIndex(prevIndex => prevIndex - 1);
          setDelta(period);
        } else if (isDeleting && updatedText === '') {
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
          setIndex(1);
          setDelta(500);
        } else {
          setIndex(prevIndex => prevIndex + 1);
        }
      }
    return (
        <section className = "banner" id = "home">
            <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi! I'm Deepan, \n`}<span className="txt-rotate" dataPeriod="1000" data-rotate='["Machine Learning Developer"," Computer Vision Developer","Deep Learning Expert"]'><span className="wrap">{text}</span></span></h1>
                  <p>Innovative Artificial Intelligence Enthusiast working towards betterment of Human Lives with automating stuff and applying AI algorithms to places where human efforts ceases. 
                  After working on number of projects in various field, I have found my deepest interest in AI, Computer Vision and Deep Learning.
                  </p>
                  <Router><HashLink to='#connect'><button onClick={() => console.log('connect')}>Let’s Connect <ArrowRightCircle size={25} /></button></HashLink></Router>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
        </section>
    )
}